import {type MutableRefObject, type Ref, type RefCallback, useCallback} from 'react';

export function useCombinedRef<T>(...refs: Array<Ref<T> | undefined>): RefCallback<T> {
  return useCallback(
    (node: T) => {
      refs.forEach(ref => {
        if (!ref) return;

        if (typeof ref === 'function') {
          ref(node);
          return;
        }

        (ref as MutableRefObject<T | null>).current = node;
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps, react-hooks/use-memo
    refs,
  );
}
